import Link from '../../views/TranslationApproval';
import { connect } from 'react-redux';
import { push } from 'connected-react-router';
import { actions } from '../../../state/assessment';
const fileSaver = require('file-saver');
const mapStateToProps = (state, ownProps) => ({
  view: ownProps.match.params.view || 'source',
  locale: ownProps.match.params.locale,
  status: state.shift.status,
  username: state.shift.auth.username,
  projectList: state.shift.assessment.RepositoryNameList,
  refrenceidList: state.shift.assessment.refrenceidList,
  clientname: state.shift.assessment.clientname,
  reference_id: state.shift.assessment.reference_id,
  quotation_id: state.shift.assessment.quotation_id,
  opportunity_num: state.shift.assessment.opportunity_num,
  translationRate: state.shift.assessment.translationRate,
  reponame: state.shift.assessment.reponame,
  srclang: state.shift.assessment.srclang,
  tgtlang: state.shift.assessment.tgtlang,
  description: state.shift.assessment.description,
  totalCost: state.shift.assessment.totalCost,
  popwindow: state.shift.status.popwindow
});

const mapDispatchToProps = (dispatch, ownProps) => {
  const { locale } = ownProps.match.params;

  return {
    transSubmitHandler: (reponame, reference_id, quotation_id,translationRate,clientname,opportunity_num) => {

      // dispatch(
      //   actions.getinfobyreferenceidForApprove(JSON.parse(JSON.parse(sessionStorage.getItem("persist:shift"))['assessment'])['reference_id'])
      // )
      dispatch(
        actions.saveapprovetranslation(reponame, reference_id, quotation_id,
          JSON.parse(JSON.parse(sessionStorage.getItem("persist:shift"))['assessment'])['translationRate']),
          clientname,opportunity_num
      );
    },

    getReferenceList: event => {
      dispatch(actions.getreferenceidlist({ value: event.target.value }.value));
    },

    getinfobyreferenceid: event => {
      dispatch(
        actions.getinfobyreferenceidForApprove({ value: event.target.value }.value)
      );
    },

    clickBackHandler: value => {
      // console.log(value);
      dispatch(push(`/${locale}/shift`));
    },
    // downloadHandler: value => {
    //   // console.log(value);
    //   dispatch(push(`/${locale}/snowflake`));
    // }

    downloadHandler: reference_id => {
      var reference_id = JSON.parse(JSON.parse(sessionStorage.getItem("persist:shift"))['assessment'])['reference_id'];
      dispatch(actions.TransdownloadRpt(reference_id)).then(({ value }) => {
        fileSaver.saveAs(value.data, `Commercial-Translation-Report-${reference_id}.pdf`);
      });
    }
  };
};

const TranslationApproval = connect(
  mapStateToProps,
  mapDispatchToProps
)(Link);

export default TranslationApproval;



// WEBPACK FOOTER //
// ./src/components/container/TranslationApproval/index.js